module.exports = __webpack_public_path__ + "img/int.5c692a12.svg";